import type { DataTableFeatures } from 'design-system';

import type { CatalogItem } from '@/entities/catalog-item';
import type { SymbolKey } from '@/entities/symbol';

import type { Row } from '@tanstack/react-table';

export const parseForwardCurveRowToSymbol = (row: Row<DataTableFeatures, CatalogItem>) => {
  const periodMin = Number(row.getValue<number>('PeriodMin'));
  const periodMax = Number(row.getValue<number>('PeriodMax'));
  // `Symbol` is deliberately excluded from the table's column defs (see
  // `useCatalogColumns`), so `table.getColumn('Symbol')` — and therefore
  // `row.getValue('Symbol')` — is always undefined. Read straight from
  // `row.original`, matching the spot selection path in
  // `useCatalogSelectionAdapter.getTargets`.
  const baseSymbol = row.original.Symbol;
  const selectedSymbols: SymbolKey[] = [];
  if (!baseSymbol) return selectedSymbols;
  for (let i = periodMin; i <= periodMax; i++) {
    selectedSymbols.push({
      Code: baseSymbol.Code,
      TimeRef: baseSymbol.TimeRef,
      Period: i.toString(),
      PeriodType: baseSymbol.PeriodType
    });
  }
  return selectedSymbols;
};
